import { asCaseId, type CaseId } from "@repo/domain";
import { z } from "zod";
import { newEntityIdSchema } from "./entity-id.schemas";
import { practitionerRefSchema } from "./practitioner.schemas";
import { codeableConceptSchema } from "./schedule.schemas";
import { visitIdSchema } from "./visit.schemas";

// === Case (Episode) Input Schemas ===

export const caseIdSchema: z.ZodType<CaseId, z.ZodTypeDef, string> = z.string().min(1).transform(asCaseId);

export const caseIdInputSchema = z.object({
  caseId: caseIdSchema,
});
export type CaseIdInput = z.infer<typeof caseIdInputSchema>;

export const assignCareManagerInputSchema = z.object({
  caseId: caseIdSchema,
  careManager: practitionerRefSchema,
});
export type AssignCareManagerInput = z.infer<typeof assignCareManagerInputSchema>;

export const linkEncounterToCaseInputSchema = z.object({
  caseId: caseIdSchema,
  visitId: visitIdSchema,
});
export type LinkEncounterToCaseInput = z.infer<typeof linkEncounterToCaseInputSchema>;

export const addCaseDiagnosisInputSchema = z.object({
  id: newEntityIdSchema,
  caseId: caseIdSchema,
  code: codeableConceptSchema,
  clinicalStatus: z.enum(["active", "recurrence", "relapse", "inactive", "remission", "resolved"]).optional(),
  verificationStatus: z
    .enum(["unconfirmed", "provisional", "differential", "confirmed", "refuted", "entered-in-error"])
    .optional(),
  onsetDateTime: z.string().optional(),
  severity: codeableConceptSchema.optional(),
  note: z.string().optional(),
});
export type AddCaseDiagnosisInput = z.infer<typeof addCaseDiagnosisInputSchema>;
